module.exports = __webpack_public_path__ + "static/feature-3-1736098bbef05f6c5d4e08222bff3ad5.svg";